import * as S from './styled'

export function AddButton() {
  return <S.Button>+</S.Button>
}
